<template>
<content-div>
	<div class="contArea">
		<!-- tabType1 -->
		<div class="tabType2">
			<ul class="col2">
			<li v-for="(item, index) in tabs" :key="index" :class="{'on': selected.tabCont === index }">
				<a @click="changeTab(index)"><span>{{item.title}}</span></a>
				<!-- <router-link :to="`/guide/${item}`"><span>{{termTitle(item)}}</span></router-link> -->
			</li>
			</ul>
		</div>

		<div class="tabCont">
			<section v-if="selected.tabCont === 0">

				<div class="subBlock hide" style="margin:0px;">
					<div class="tabType3 noSidePadding">
					<ul>
						<li v-for="(item, key) in pkgs" :key="key" :class="{'on': selected.group === key }">
						<a @click="changePkgTab(key)"><span>{{item.group}}</span></a>
						</li>
					</ul>
					</div>
				</div>

				<div class="contArea">
					<swiper class="swiper app_book" :options="swiperOption" style="margin-top:0px;">
					<swiper-slide class="item" v-for="(item,idx) in contents" :key="item.id">
						
						<div class="app_book_img">
							<img :src="`${$store.state.dir}images/step/nstep${item.id + (( item.id == 2 || item.id == 4 || item.id == 9 ) ? selected.group == 1 ? '_2' : '_1' : '')}.png`">
						</div>

						<!--0323추가-->
						<div class="back_slide">
							<div class="text">
								<dl>
									<dt>STEP {{idx+1}}</dt>
									<dd>{{item.title}}</dd>
								</dl>
							</div>
						</div>
						<!--0323추가-->
					</swiper-slide>


					<div v-if="isFraction" class="swiper-button-prev" slot="button-prev"></div>
					<div v-if="isFraction" class="swiper-button-next" slot="button-next"></div>
					<div class="swiper-pagination" slot="pagination"></div>
					</swiper>

					<!-- <button-app-download v-if="!$store.state.isApp"></button-app-download> -->

				</div>
			</section>

			<section v-else>
				
				<div class="subBlock" style="margin:0px;display:none;"></div>
				
				<div class="contArea" style="margin-bottom:40px;" v-for="(item, index) in filteredHowToUses" :key="index">
					<div class="sub_copy">
						<h3 class="sub_copy_title" style="font-weight: 700; font-size:15px; line-height: 22px; color: #262626;"
						:style="(item.categoryDetail ? 'margin-bottom: unset;' : '')">
							{{ item.category }}
						</h3>
						<h4 v-if="item.categoryDetail" style="font-weight: 300; font-size:12px; line-height: 18px; color: #4D4D4D;">
							{{ item.categoryDetail }}
						</h4>
					</div>
					
					<ul class="prodWrap">
						<li v-for="(ctt, idx) in item.content" :key="idx" style="padding: 10px 10px;"
						:style="idx < item.content.length-1 ? 'border-bottom: 1px solid #DDDDDD;' : ''">
							<img :src="`${$store.state.dir}images/guide/${ctt.icon}.png`" alt="" style="width: 28px; height: 28px;">
							<dl>
								<dt v-if="ctt.title" style="font-size: 14px; line-height: 20px; font-weight: 400;">
									{{(item.content.length > 1 ? idx+1 + '.' : '') + ctt.title }}
								</dt>
								<dd v-if="ctt.datas && typeof ctt.datas == 'string'">{{ ctt.datas }}</dd>
								<dd v-else-if="ctt.datas && typeof ctt.datas == 'object'" v-for="(data, key) in ctt.datas" :key="key">
									<span style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;" :style="data.style ? data.style : ''">
										{{ data.symbol + (data.symbol ? ' ' : '') + data.detail }}
									</span>
									<br v-if="key < ctt.datas.length">
								</dd>

								<dd v-if="ctt.html" style="font-size: 12px; line-height: 18px; font-weight: 300;" v-html="ctt.html"></dd>
								
								<div v-if="index != 0 && idx === (item.content.length-1) " class="sub_copy" style="margin-top:20px;">
									<span style="font-size: 12px; line-height: 18px; font-weight: 400;">{{$store.state.insuranceName}} 고객 센터</span>
									<p style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;">
										<span>※ 전화번호 : {{envServer.tell}} / {{envServer.tell2}}</span><br>
										<span>※ 운영시간 : 월 ~ 금: 9시-18시</span><br>
										<span v-if="index === 1">
											※ 사전 승인 절차에서 {{$store.state.insuranceName}} 사용이 반려될 수 있습니다.<br>
											※ 보다 자세한 사항은 서비스 약관을 통해 확인하실 수 있습니다.<br>
											※ {{envServer.email}} 해당 이메일 주소로 제출해 주세요.
										</span>
										<span v-if="index === 2">※ 이메일 주소 : {{envServer.email}}</span>
									</p>
								</div>
							</dl>
						</li>
					</ul>
					
				</div>

			</section>
		</div>
	</div>
</content-div>
</template>
	
	
<script>
import { mapState } from 'vuex';
import Const from '../../helpers/Const';
import Format from '../../helpers/Format';

export default {
	name: 'GuideTotal',

	components: {
	},
	filters: Format,
	
	created () {
		this.selected.group = (this.$route.query.group == 'POWER TRAIN' ? 1 : 0);
		
		const cPkgs = this.$store.state.pkgs;

		if(cPkgs) {

			let pkgCnt = 0;

			for(const key in cPkgs) {
				if((cPkgs[key].group === 'STANDARD' || cPkgs[key].group === 'PREMIUM') 
					&& this.pkgs.some(e=> e.group === 'STANDARD/PREMIUM')) continue;

				if(cPkgs[key].group === 'POWER TRAIN'
					&& this.pkgs.some(e=> e.group === 'POWER TRAIN')) continue;

				let tmpGroup = (cPkgs[key].group === 'STANDARD' || cPkgs[key].group === 'PREMIUM' ? 'STANDARD/PREMIUM': cPkgs[key].group);

				let tmpMap = {
					id: pkgCnt,
					group: tmpGroup
				}

				this.pkgs.push(tmpMap);

				pkgCnt++;
			}

			this.howToUses.forEach(e=> {
				e.enabled = this.pkgs.some(ee=>ee.group === e.group);
			});

		} else {
			this.pkgs = [
				{id: 0, group: 'STANDARD/PREMIUM'},
				{id: 1, group: 'POWER TRAIN'}
			];
		}

	},
	data() {
		return {
			selected: {
				tabCont: 0,
				group: 0,
			},
			tabs: [
				{title: '구독 신청 방법' },
				{title:'이용 방법'}
			],
			Const,
			item:{
				id:0,
			},
			numId: '',
			pkgs: [],
			howToUses: [
				{
					category:'ServiceCare+ 이용 방법',
					content: [
						{icon: 'micon0', title: 'ServiceCare+ 가입', html: 'BMW Vantage 통해 ServiceCare+에 가입하세요.'},
						{icon: 'micon1', title: '실시간 예약', html: 'MyBMW 앱에서 서비스를 쉽고 빠르게 예약하세요.'},
						{icon: 'micon2', title: '차량 정비', html: '예약한 일정에 BMW 공식 딜러 서비스 센터를 방문하고 차량 정비를 받으세요.'},
						{icon: 'micon3', title: 'ServiceCare+ 쿠폰 활용'
							, datas: [
								{symbol:'', detail: 'BMW Vantage > 우측상단 차량관리 > MyService > ServiceCare+ 메뉴에서 활성화된 쿠폰을 사용하세요.'},
								{symbol:'', detail: '(사용한 쿠폰은 영업일 기준 5일 이내로 비활성화 될 예정입니다.)'},
							]
						},
					],
					group: 'STANDARD/PREMIUM',
					enabled: true,
				},
				{
					category:`${this.$store.state.insuranceName.toUpperCase()} 이용 방법`,
					content: [
						{icon: 'micon4', title: '차량 점검', html: 'BMW 공식 서비스 센터에 방문하여 차량을 점검 받으세요.'},
						{icon: 'micon0', title: '가견적 및 작업지시서', html: '진단기 검사 진행 후에 가견적서 및 작업지시서를 받으세요.'},
						{icon: 'micon5', title: '청구 가능 여부 확인', html: '담당 서비스 어드바이저가 사전승인절차를 통해 청구 가능 여부를 확인하여 알려드려요.'},
						{icon: 'micon6', title: '수리비용 환급', html: `차량 수리 완료 후, 서비스 센터에 비용을 지급하신 이후에 청구서류를 제출하시면,${this.$store.state.insuranceName}고객센터에서 수리비용을 환급해 드립니다.`
						},
					],
					group:'POWER TRAIN',
					enabled: true,
				},
				{
					category:`${this.$store.state.insuranceName.toUpperCase()} 금액 청구 방법`,
					categoryDetail: `${this.$store.state.insuranceName} 수리완료 후 청구 서류를 제출하시고 수리비를 환급 받으세요`,
					content: [
						{icon:'micon7', title: '청구서류'
						, datas: [
							{symbol:'-', detail: '청구 (위임장 및 동의서)'},
							{symbol:'-', detail: '신분증 사본'},
							{symbol:'-', detail: '통장사본'},
							{symbol:'-', detail: '차량등록증'},
							{symbol:'-', detail: '차량등록증'},
							{symbol:'-', detail: '자동차 검사표'},
							{symbol:'-', detail: '전면사진 (번호판 포함)'},
							{symbol:'-', detail: '차량계기판 사진 (주행거리 포함)'},
							{symbol:'-', detail: '수리 견적서 (BMW 공식 딜러 서비스 센터에서 요청)'},
							{symbol:'-', detail: '수리비 영수증 (BMW 공식 딜러 서비스 센터에서 요청)'},
							{symbol:'-', detail: '대량 부품 수리 전후 사진 (BMW 공식 딜러 서비스 센터에서 요청)'},
							{symbol:'※', detail: '단, 가견적을 통한 청구 가능여부와 실제 보상여부는 상이할 수 있으며, 보상의 세부사항은 BMW ServiceCare+ 이용약관을 따릅니다.'},
							{symbol:'※', detail: '청구 금액은 서류 검토 완료 후, 영업일 기준 7일 이내에 지급될 예정입니다.'},
							{symbol:'※', detail: `보험금 청구 문의는 ${this.$store.state.insuranceName} 고객센터로 문의 바랍니다.`},
						]}
					],
					group:'POWER TRAIN',
					enabled: true,
				}
			],
			groups: [],
			swiperOption: {
				loop: false,
				slidesPerView: 1, //화면에 slide 노출 개수
				spaceBetween: 5, //거리
				pagination:{
					el: '.swiper-pagination',
					type: 'bullets',
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			},
			isFraction: false,
		}
	},

	computed:{
		
		contents() {
			let returnList = null;

			let contents = [
				{ id:1, title: 'BMW Vantage 접속', insurance: false, },
				{ id:2, title: 'ServiceCare+ 초기화면', insurance: false, },
				{ id:3, title: '서비스 신청 & 구비서류 준비', insurance: true, },
				{ id:4, title: '차량정보 확인', insurance: false, },
				{ id:5, title: '가입 대상 여부 확인', insurance: true, },
				{ id:6, title: '차량등록증 촬영', insurance: true, },
				{ id:7, title: '자동차정기검사결과표 촬영', insurance: true, },
				{ id:8, title: '자동차 계기판 촬영', insurance: true, },
				{ id:9, title: '간편 결제를 통한 구매 완료', insurance: false, },
			];

			if(this.selected.group == 0) {
				returnList = contents.filter(e=> e.insurance == false);
			} else {
				returnList = contents;
			}

			return returnList;
		},

		filteredHowToUses() {
			return this.howToUses.filter(e=>e.enabled === true);
		},

		...mapState({
			envServer: state => state.envServer,
			user: state => state.user,
			btnLoading: state => state.btnLoading,
		}),

		careInsuranceConfirmId() { return this.$route.params.careInsuranceConfirmId; },
		
	},

	methods: {
		changeTab(idx) {
			this.selected.tabCont = idx;
		},

		changePkgTab(selectPkgGroup) {
			if(selectPkgGroup == undefined || selectPkgGroup == null) selectPkgGroup = 0;
			
			this.selected.group = selectPkgGroup;
			this.tglOn = true;

			let mySwiper = document.querySelector('.swiper-container').swiper
			mySwiper.slideTo(this.groups.indexOf(selectPkgGroup));
		},
	},
}
</script>

<style scoped>
.swiper-pagination {
  position: absolute;
  top: 10px;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
  background-image: none;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  background-image: none;
}

.swiper-button-prev.swiper-button-disabled {
  display: none;
}
.swiper-button-next.swiper-button-disabled {
  display: none;
}

.svTitSub {
  color:#fff;
  font-size:12px;
  line-height: 20px;
  text-align: center;
  margin-top: 20px;
}
</style>